import NavigationLayout from "./NavigationLayout";
import MemberDrawerContent from "./MemberDrawerContent";
import { AccountType } from "protogen/common_pb";
import { SnackpackContextProvider } from "../context/SnackpackContextProvider";
import SocketConsumerProvider from "components/context/SocketConsumerProvider";
import { VideoCallContextProvider } from "components/context/VideoCallContext";
import MemberStatusContextProvider from "components/context/MemberStatusContextProvider";
import { useUnpaidBanner } from "components/context/UnpaidBannerContext";

export default () => {
  const { isUnpaid, loading } = useUnpaidBanner();
  return (
    <NavigationLayout
      drawerContent={MemberDrawerContent}
      loginRedirectPath="/member-login"
      tosAccountType={AccountType.MEMBER}
      hideInstallPrompt={loading || isUnpaid}
      authedContexts={[
        SocketConsumerProvider,
        VideoCallContextProvider,
        SnackpackContextProvider,
        MemberStatusContextProvider,
      ]}
    />
  );
};
